import React from 'react';
import './press-center.scss';
import { QuestionsBlock } from '/react4xp/parts/questions-block/questions-block.type';
import { Col, Row } from 'antd';
import { localize } from 'mixins/helpers';

function PressCenter(props: QuestionsBlock.Props) {
    const lang = props.language || 'ru';

    const handleClick = () => {
        window.location.href = `/${lang}/pages/press-center`;
    };

    return (
        <div
            className="questions-block-center clickable"
            onClick={handleClick}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && handleClick()}
        >
            <Row gutter={[16, 16]} align="middle">
                <Col xs={24} md={16} className="question">
                    {localize('press-center', props.translations)}
                </Col>
            </Row>
        </div>
    );
}

export default PressCenter;